<div class="fade-in">
  <div class="content-section">
    <div class="section-header">
      <h2>Store Management</h2>
      <button type="button" class="primary-btn" (click)="openAddModal()">Add New Store</button>
    </div>

    <!-- Modal Form for Add/Edit -->
    <div class="modal-overlay" *ngIf="isModalOpen" (click)="cancelEdit()">
      <div class="store-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <h3 class="modal-title">{{ editingId ? 'Edit Store' : 'Add New Store' }}</h3>
          <button type="button" class="modal-close-btn" (click)="cancelEdit()">×</button>
        </div>

        <div *ngIf="storeFormError" class="form-error-alert">
          {{ storeFormError }}
        </div>
        
        <div class="store-form-grid">
          <div class="form-group">
            <label class="form-label" for="storeIdInput">Store ID <span class="required-star">*</span></label>
            <input id="storeIdInput" [(ngModel)]="newStore.storeId" placeholder="e.g. S-101" class="form-input">
          </div>
          <div class="form-group">
            <label class="form-label" for="storeNameInput">Store Name <span class="required-star">*</span></label>
            <input id="storeNameInput" [(ngModel)]="newStore.name" placeholder="Store Name" class="form-input">
          </div>
          <div class="form-group">
            <label class="form-label" for="friendlyNameInput">Friendly Store Name</label>
            <input id="friendlyNameInput" [(ngModel)]="newStore.friendlyName" placeholder="Displayed in User Portal (e.g. Westfield Valley Fair)" class="form-input">
          </div>
          <div class="form-group">
            <label class="form-label" for="countrySelect">Country</label>
            <select id="countrySelect" [(ngModel)]="newStore.country" class="form-input form-select">
              <option value="">Select Country</option>
              <option *ngFor="let c of countries$ | async" [value]="c.name">{{ c.name }}</option>
            </select>
          </div>
          <div class="form-group form-full-width">
            <label class="form-label" for="locationInput">Location</label>
            <input id="locationInput" [(ngModel)]="newStore.location" placeholder="City, State or Address" class="form-input">
          </div>

          <!-- Section 1: Photobooth Pricing (PhotoLavie) -->
          <div class="pricing-card-section form-full-width">
            <h4 class="section-subtitle">📸 Photobooth Pricing (PhotoLavie)</h4>
            <div class="pricing-inputs-grid">
              <div class="form-group">
                <label class="form-label" for="priceClassicInput">
                  Price (Classic Strip) <span class="field-hint">(Per 2 copies)</span>
                </label>
                <div class="price-input-wrapper">
                  <span class="price-currency-symbol">$</span>
                  <input id="priceClassicInput" type="number" [(ngModel)]="newStore.priceClassicStrip" class="form-input price-num-input" min="0" step="1.00" placeholder="10.00">
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="priceMultiCutInput">
                  Price (Multi-Cut) <span class="field-hint">(Per 2 copies)</span>
                </label>
                <div class="price-input-wrapper">
                  <span class="price-currency-symbol">$</span>
                  <input id="priceMultiCutInput" type="number" [(ngModel)]="newStore.priceMultiCut" class="form-input price-num-input" min="0" step="1.00" placeholder="10.00">
                </div>
              </div>
            </div>
          </div>

          <!-- Section 2: Konobox Karaoke Pricing (per song, KAN-697) -->
          <div class="pricing-card-section form-full-width" id="konoboxPricingSection">
            <div class="pricing-header-row">
              <h4 class="section-subtitle">🎤 Konobox Pricing (Per Song)</h4>
              <span *ngIf="pricingDefaultedAny" class="status status-info" title="This store has not saved its own Konobox pricing yet.">Default pricing</span>
            </div>
            <p *ngIf="pricingDefaultedAny" class="info-note" role="note">{{ pricingDefaultedNote }}</p>

            <div class="form-group pricing-price-group">
              <label class="form-label" for="pricePerSongInput">Price per song</label>
              <div class="price-input-wrapper">
                <span class="price-currency-symbol">$</span>
                <input id="pricePerSongInput" type="number" class="form-input price-num-input"
                  [class.input-error]="showPriceError()" [(ngModel)]="newStore.pricePerSong" name="pricePerSong"
                  min="0.01" step="0.01" placeholder="2.00" (blur)="markPriceTouched()"
                  [attr.aria-invalid]="showPriceError()" aria-describedby="pricePerSongHint pricePerSongError">
              </div>
              <span id="pricePerSongHint" class="field-hint">Package price = number of songs x price per song.</span>
              <span id="pricePerSongError" *ngIf="showPriceError()" class="field-error" role="alert">{{ pricingErrors.price }}</span>
            </div>

            <div class="form-label packages-heading" id="packagesHeading">Packages (number of songs)</div>
            <div class="package-inputs-grid" role="group" aria-labelledby="packagesHeading">
              <div class="form-group" *ngFor="let i of packageSlots">
                <label class="form-label" [attr.for]="'packageInput' + i">Package {{ i + 1 }}</label>
                <div class="package-input-wrapper">
                  <input [id]="'packageInput' + i" type="number" class="form-input package-num-input"
                    [class.input-error]="showCountError(i)" [(ngModel)]="newStore.songCounts[i]" [name]="'songCount' + i"
                    [min]="packageLimits.minSongs" [max]="packageLimits.maxSongs" step="1" (blur)="markCountTouched(i)"
                    [attr.aria-invalid]="showCountError(i)" [attr.aria-describedby]="'packageError' + i">
                  <span class="package-suffix">songs</span>
                </div>
                <span [id]="'packageError' + i" *ngIf="showCountError(i)" class="field-error" role="alert">{{ pricingErrors.counts[i] }}</span>
              </div>
            </div>

            <div class="kiosk-preview" aria-live="polite">
              <span class="kiosk-preview-title">Kiosk preview</span>
              <div class="kiosk-preview-chips">
                <span *ngFor="let chip of pricingPreviewChips" class="preview-chip" [class.preview-chip-empty]="!chip.valid">{{ chip.label }}</span>
              </div>
            </div>

            <p *ngIf="pricingErrors.hasErrors && (pricingSubmitAttempted || pricingPriceTouched || pricingCountTouched.includes(true))" class="field-error pricing-summary-error" role="alert">{{ pricingSummaryError }}</p>
          </div>

          <div class="form-group form-full-width">
            <label class="form-label" for="assignedCompanyInput">Assigned Company</label>
            <input id="assignedCompanyInput" type="text" [value]="getCompanyNames(newStore)" readonly
              class="form-input" placeholder="Assigned via Company Management" />
          </div>
        </div>

        <!-- Device Management Section -->
        <div class="devices-section">
          <div class="devices-header">
            <h4 class="devices-title">Devices</h4>
            <button type="button" class="secondary-btn btn-small" (click)="addDevice()">+ Add Device</button>
          </div>
          
          <div class="devices-table-wrapper">
            <table class="devices-table">
              <thead>
                <tr>
                  <th>Device ID</th>
                  <th>Device Name</th>
                  <th>Merchant ID</th>
                  <th>Ref No</th>
                  <th>Terminal ID</th>
                  <th>Auth Code</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let device of newStore.devices; let i = index">
                  <td><input [(ngModel)]="device.deviceId" class="table-input" placeholder="Device ID"></td>
                  <td><input [(ngModel)]="device.deviceName" class="table-input" placeholder="Device Name"></td>
                  <td><input [(ngModel)]="device.merchantId" class="table-input" placeholder="Merchant ID"></td>
                  <td><input [(ngModel)]="device.refNo" class="table-input" placeholder="Ref No"></td>
                  <td><input [(ngModel)]="device.terminalId" class="table-input" placeholder="Terminal ID"></td>
                  <td><input [(ngModel)]="device.authCode" class="table-input" placeholder="Auth Code"></td>
                  <td class="text-center">
                    <button type="button" class="btn-delete-device" (click)="removeDevice(i)" title="Remove">🗑️</button>
                  </td>
                </tr>
                <tr *ngIf="!newStore.devices || newStore.devices.length === 0">
                  <td colspan="7" class="empty-devices-row">No devices added yet.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="modal-actions">
          <button type="button" class="secondary-btn" (click)="cancelEdit()" [disabled]="isSaving">Cancel</button>
          <button type="button" class="primary-btn" (click)="saveStore()" [disabled]="isSaving || pricingErrors.hasErrors">
            <span *ngIf="!isSaving">{{ editingId ? 'Update Store' : 'Add Store' }}</span>
            <span *ngIf="isSaving" class="spinner-small"></span>
            <span *ngIf="isSaving"> Saving...</span>
          </button>
        </div>
      </div>
    </div>

    <div class="stores-count-bar">
      <div class="stores-count-left">
        <div class="stores-count-title">
          Stores ({{ storesCount$ | async }})
        </div>
        <button type="button" class="sync-btn" (click)="syncCounts()" [disabled]="isSyncingCounts" title="Recalculate and update device counts for all stores">
          <span *ngIf="isSyncingCounts">🔄 Syncing...</span>
          <span *ngIf="!isSyncingCounts">🔄 Sync Device Counts</span>
        </button>
      </div>
      <button type="button" class="danger-btn fade-in" *ngIf="selectedStoreIds.size > 0" (click)="deleteSelectedStores()">
        Delete Selected ({{ selectedStoreIds.size }})
      </button>
    </div>

    <div class="table-container">
      <table class="ledger-table">
        <ng-container *ngIf="stores$ | async as stores">
          <thead>
            <tr>
              <th class="th-checkbox"><input type="checkbox" class="store-checkbox" title="Select All" [checked]="isAllSelected(stores)" (change)="toggleAll($event, stores)"></th>
              <th>Store ID</th>
              <th>Store Name</th>
              <th>Friendly Store Name</th>
              <th class="text-center">Machines</th>
              <th>Country</th>
              <th>Location</th>
              <th>Companies</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let store of stores">
              <td class="td-checkbox"><input type="checkbox" class="store-checkbox" [checked]="selectedStoreIds.has(store.id!)" (change)="toggleSelection(store.id)"></td>
              <td class="store-code-cell">{{ store.storeId }}</td>
              <td class="store-name-cell">{{ store.name }}</td>
              <td class="friendly-name-cell">
                <span *ngIf="store.friendlyName || store.friendlyStoreName" class="badge-friendly-name">
                  {{ store.friendlyName || store.friendlyStoreName }}
                </span>
                <span *ngIf="!store.friendlyName && !store.friendlyStoreName" class="text-muted">—</span>
              </td>
              <td class="machines-cell text-center">
                <span class="machine-count-badge" [class.has-machines]="((store.deviceCount || 0) > 0)">
                  📷 {{ store.deviceCount || 0 }}
                </span>
              </td>
              <td class="country-cell">{{ store.country || '—' }}</td>
              <td class="location-cell">{{ store.location || '—' }}</td>
              <td class="companies-cell">{{ getCompanyNames(store) || '—' }}</td>
              <td class="actions-cell text-center">
                <button type="button" class="icon-btn" (click)="editStore(store)" title="Edit">✏️</button>
                <button type="button" class="icon-btn" (click)="deleteStore(store.id)" title="Delete">🗑️</button>
              </td>
            </tr>
            <tr *ngIf="stores.length === 0">
              <td colspan="9" class="empty-stores-cell">
                No stores found. Add a new store above.
              </td>
            </tr>
          </tbody>
        </ng-container>
      </table>
    </div>
  </div>
</div>